export const ProcurementRequestPath = {
  PROCUREMENT: 'procurement',
  PROCUREMENT_PURCHASE_REQUEST: 'purchase-request',
  PROCUREMENT_CREATE_TENDER_REQUEST: 'create',
  PROCUREMENT_CONFIRM_TENDER_REQUEST: 'confirm',
  PROCUREMENT_TENDER_REQUEST: 'tender-request',
  PREVIOUS_PRICING: ':tenderId/previous-pricing',
  COMPARISON_SHEET: 'comparison-sheet/:tenderId/:taskId',
  COMPARISON_SHEET_MATERIALS: '',
  COMPARISON_SHEET_SELECTED: 'selected',
  COMPARISON_SHEET_APPROVE: 'approve',
};
